export const LOAD_METATAG = 'LOAD_METATAG';
export const SAVE_METATAG = 'SAVE_METATAG';